import React, { useContext } from 'react';
import PropTypes, { shape } from 'prop-types';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { Alert } from '@thd-olt-component-react/alert';
import { CheckNearByStore } from './CheckNearbyStore';
import {
  getSellableQuantityYourStore,
  isLiveGoods,
  productShape
} from '../../helpers/pod-fulfillment-utils';

export const InStock = ({
  product,
  onCheckNearbyStoresClick
}) => {
  const {
    channel
  } = useContext(ExperienceContext);

  const { storeName } = useStore();

  if (!(product && storeName)) {
    return null;
  }

  const sellableQuantity = getSellableQuantityYourStore(product);
  if (!sellableQuantity) {
    return null;
  }
  const formattedQty = sellableQuantity > 999 ? '999+' : sellableQuantity;
  const inStoreSuccessMsg = 'Buy in store';
  const isLiveGoodsProduct = isLiveGoods(product);

  return (
    isLiveGoodsProduct ? (
      <>
        <Alert type="success" message={inStoreSuccessMsg} inline>
          <div className="u__text--primary">{formattedQty} in stock at {storeName}</div>
        </Alert>
      </>
    ) : (
      <>
        <Alert type="success" inline>
          {formattedQty} <span className="store__alert--black">in stock at</span> {storeName}
        </Alert>
        {channel !== 'mobile' && (
          <div className="store__new-line">
            <CheckNearByStore
              product={product}
              onCheckNearbyStoresClick={onCheckNearbyStoresClick}
            />
          </div>
        )}
      </>
    )
  );
};

InStock.propTypes = {
  product: PropTypes.shape({ productShape }).isRequired,
  onCheckNearbyStoresClick: PropTypes.func,
};

InStock.defaultProps = {
  onCheckNearbyStoresClick: null
};
